<section id="cabecalho" [style.background-image]="'url(' + (bgImage) + ')'">    
    <div class="container">
        <div class="row d-flex align-items-center">
            <div class="col-lg-12">
                <h6 class="mb-4">{{ data.TITULO }}</h6>
                <h3>{{ data.SUBTITULO }}</h3>
            </div>
        </div>
    </div>
</section>